import Statistics from './Statistics';
import QuickActions from './QuickActions';
import RecentActivity from './RecentActivity';
import CompanyOverview from './CompanyOverview';

export default {
  Statistics,
  QuickActions,
  RecentActivity,
  CompanyOverview,
};
